module.exports = __webpack_public_path__ + "static/img/6.34c3826.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/6.png
// module id = jyr0
// module chunks = 0